<div class="mobility-profile-detail">
  <ng-container [ngSwitch]="variant">
    <!-- NewItinerary View -->
    <ng-container *ngSwitchCase="'newItinerary'">
      <div id="new-itinerary-mobility-profile" class="new-itinerary-mobility-profile">
        <div class="last-updated-date flex-row">
          <div id="mobility-profile-last-updated-header" class="last-updated-date-header">Last updated:</div>
          <div id="mobility-profile-last-updated-content" class="last-updated-date-content">
            {{ updatedMobilityProfileDetail?.lastUpdated | date : 'MM/dd/yyyy' }}
          </div>
        </div>

        <div id="mobility-profile-content-newItinerary" class="mobility-profile-content flex-row">
          <div id="mobility-profile-section-mobility-aid" class="mobility-profile-section flex-col">
            <div id="mobility-profile-content-label-mobilityAid" class="mobility-profile-content-label">
              {{ updatedMobilityProfileDetail?.mobilityAid?.label }}
            </div>
            <div
              id="mobility-profile-content-option-{{ optionIndex }}"
              class="mobility-profile-content-option"
              *ngFor="let option of updatedMobilityProfileDetail?.mobilityAid?.options; let optionIndex = index"
            >
              <div id="mobility-profile-option-label-{{ option.label | camelCase }}"
                   class="option-label">{{ option.label }}
              </div>
              <ul id="mobility-profile-content-option-list" class="mobility-profile-content-option-list">
                <li
                  *ngFor="let item of option.options; let itemIndex = index"
                  id="mobility-profile-content-{{ option.label | camelCase }}-item-{{ item.label | camelCase }}">
                  {{ item.label }}
                </li>
              </ul>
            </div>
          </div>

          <div id="mobility-profile-section-mobility-assistance" class="mobility-profile-section flex-col">
            <div id="mobility-profile-content-label-mobilityAssistance" class="mobility-profile-content-label">
              {{ updatedMobilityProfileDetail?.mobilityAssistance?.label }}
            </div>
            <div
              id="mobility-profile-content-option-{{ optionIndex }}"
              class="mobility-profile-content-option"
              *ngFor="let option of updatedMobilityProfileDetail?.mobilityAssistance?.options; let optionIndex = index"
            >
              <div id="mobility-profile-option-label-{{ option | camelCase }}" class="option-label">{{ option }}</div>
            </div>
          </div>

          <div id="mobility-profile-section-disabilities-and-health" class="mobility-profile-section flex-col">
            <div id="mobility-profile-content-label-disabilitiesAndHealth" class="mobility-profile-content-label">
              {{ updatedMobilityProfileDetail?.medicalAndHealth?.label }}
            </div>
            <div
              id="mobility-profile-content-option-{{ optionIndex }}"
              class="mobility-profile-content-option"
              *ngFor="let option of updatedMobilityProfileDetail?.medicalAndHealth?.options; let optionIndex = index"
            >
              <div id="mobility-profile-option-label-{{ option| camelCase }}" class="option-label">{{ option }}</div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- TripDetail View -->
    <ng-container *ngSwitchCase="'tripDetail'">
      <div id="trip-detail-mobility-profile" class="trip-detail-mobility-profile">
        <div id="mobility-profile-content-label" class="mobility-profile-content-label">Mobility Profile</div>
        <div id="mobility-profile-content-tripDetail" class="mobility-profile-content">
          <div
            id="mobility-profile-content-option-{{ optionIndex }}"
            *ngFor="let option of updatedMobilityProfileDetail?.mobilityAid.options; let optionIndex = index"
          >
            <div id="option-label" class="option-label">{{ option.label }}</div>
            <ul>
              <li
                *ngFor="let item of option.options; let itemIndex = index"
                id="mobility-profile-content-option-item-{{ itemIndex }}">
                {{ item.label }}
              </li>
            </ul>
          </div>
          <div *ngFor="let option of updatedMobilityProfileDetail?.mobilityAssistance.options">
            <div id="mobility-profile-option-label-{{ option }}" class="option-label">{{ option }}</div>
          </div>
          <div *ngFor="let option of updatedMobilityProfileDetail?.medicalAndHealth.options">
            <div id="mobility-profile-option-label-{{ option }}" class="option-label">{{ option }}</div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- IDK Variant -->
    <ng-container *ngSwitchDefault>
      <p>Unknown view variant: "{{ variant }}"</p>
    </ng-container>
  </ng-container>
</div>
